import {
  SnippetElement,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/shop-mobile-navigation/shop-mobile-navigation.ts
var ShopMobileNavigation = class extends SnippetElement {
  closeNavModal() {
    var _a;
    (_a = this.allCategoriesMenu) == null ? void 0 : _a.close();
  }
  openNavModal() {
    var _a;
    (_a = this.allCategoriesMenu) == null ? void 0 : _a.open();
  }
  handleOpenLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkButton;
    console.log({ handle });
    if (handle == null || typeof handle === "undefined")
      return;
    console.log(this.linkDrawers.find((d) => d.key === handle));
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
    console.log(this.linkDrawers.find((d) => d.key === handle));
  }
  handleOpenChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleCloseLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  handleCloseChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
};
__decorateClass([
  query("[data-all-categories-menu-open]")
], ShopMobileNavigation.prototype, "navModalOpen", 2);
__decorateClass([
  query("[data-all-categories-menu-drawer]")
], ShopMobileNavigation.prototype, "allCategoriesMenu", 2);
__decorateClass([
  queryAll("[data-link-drawer]")
], ShopMobileNavigation.prototype, "linkDrawers", 2);
__decorateClass([
  queryAll("[data-child-link-drawer]")
], ShopMobileNavigation.prototype, "childLinkDrawers", 2);
__decorateClass([
  globalOn("cart:open"),
  onClick("[data-menu-close]")
], ShopMobileNavigation.prototype, "closeNavModal", 1);
__decorateClass([
  onClick("[data-all-categories-menu-open]")
], ShopMobileNavigation.prototype, "openNavModal", 1);
__decorateClass([
  onClick("[data-link-button]")
], ShopMobileNavigation.prototype, "handleOpenLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-button]")
], ShopMobileNavigation.prototype, "handleOpenChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-link-drawer-close]")
], ShopMobileNavigation.prototype, "handleCloseLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-drawer-close]")
], ShopMobileNavigation.prototype, "handleCloseChildLinkDrawer", 1);
ShopMobileNavigation = __decorateClass([
  defineElement("shop-mobile-navigation")
], ShopMobileNavigation);
export {
  ShopMobileNavigation
};
